import React from 'react';

import { TableCell, TableRow } from '@mui/material';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import ModalContainer from '../../../ModalContainer';

const StyledTableCell = styled(TableCell)`
    vertical-align: top;
`;

interface RowProps {
    error: any;
    style?: any;
}

const TroubleshootingErrorRow: React.FC<RowProps> = ({ style, error }) => {
    console.log('insightError', error);
    const { pushModalContent } = useContainer(ModalContainer);

    const onClick = () => {
        pushModalContent(
            <pre style={{ fontSize: '12px', lineHeight: '14px', maxWidth: '100%', overflow: 'auto' }}>
                {JSON.stringify(error.stack, null, 2)}
            </pre>
        );
    };
    return (
        <>
            <TableRow style={style} onClick={onClick}>
                <StyledTableCell onClick={onClick}>{error.platform}</StyledTableCell>
                <StyledTableCell onClick={onClick}>{error.count}</StyledTableCell>
                <StyledTableCell onClick={onClick}>{error.error_message}</StyledTableCell>
            </TableRow>
        </>
    );
};

export default TroubleshootingErrorRow;
